<template>
  <div>
    <ResponsiveText
      v-if="titleKey"
      class="box-title mb-4"
    >
      <span :data-i18n="titleKey">
        {{ $t(titleKey) }}
      </span>
    </ResponsiveText>
    <div
      v-if="captionKey"
      class="mb-6 md:pb-2 box-caption"
    >
      <div class="inline mr-2">
        –
      </div>
      <div
        class="inline font-normal"
        :data-i18n="captionKey"
      >
        {{ $t(captionKey) }}
      </div>
    </div>
    <p
      v-if="textKey"
      class="mb-6"
      :data-i18n="textKey"
    >
      {{ $t(textKey) }}
    </p>
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    size: {
      type: String,
      default: 'md',
    },

    titleKey: {
      type: String,
      default: '',
    },

    captionKey: {
      type: String,
      default: '',
    },

    textKey: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss">
.box {
  &-title {
    font-family: theme('fontFamily.secondary');
    font-size: 3.4rem;
    font-weight: 900;
    line-height: 1.3em;

    @media (max-width: theme('screens.md')) {
      font-size: 2.5rem;
    }

    @media (max-width: theme('screens.sm')) {
      font-size: 2.2rem;
    }
  }

  &-caption {
    font-family: theme('fontFamily.fancy');
    font-size: 1.4rem;
    font-weight: 900;
    line-height: 36px;

    @media (max-width: theme('screens.md')) {
      font-size: 1.2rem;
      line-height: 30px;
    }
  }
}
</style>
